module.exports = __webpack_public_path__ + "img/LogoTopQ.e413d86e.png";